import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'slotcom-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  standalone: true,
})
export class SearchInputComponent implements OnInit {
  @Input() label = '';
  @Input() autofocus = false;
  @Output() valueChange = new EventEmitter<string>();
  @Output() blurInput = new EventEmitter<void>();

  @ViewChild('searchInput') inputElement: ElementRef;

  isFocused = false;

  ngOnInit(): void {
    if (this.autofocus) {
      setTimeout(() => this.inputElement?.nativeElement.focus());
    }
  }
}
